import { resolveDefectPanelContext } from '@/utils/map/resolveDefectPanelContext';

function pickFirst(...values) {
  for (const value of values) {
    if (value != null && value !== '') {
      return value;
    }
  }
  return null;
}

/**
 * Drawer 트리·지도 라벨용 Array/String/Module 식별 필드 정규화
 * (WFS flat 필드 + resolveDefectPanelContext 병합, displayId 없으면 seq 폴백)
 */
export function resolveDefectHierarchyFields(defect) {
  if (!defect) {
    return {
      solarModuleSeq: null,
      solarStringSeq: null,
      solarArraySeq: null,
      moduleDisplayId: null,
      stringDisplayId: null,
      arrayDisplayId: null
    };
  }

  const ctx = resolveDefectPanelContext({ defect });

  const explicitModuleSeq = pickFirst(defect.solarModuleSeq, defect.solar_module_seq);
  let solarModuleSeq = explicitModuleSeq;
  if (solarModuleSeq == null && ctx.solarModuleSeq != null) {
    // WFS 행의 seq는 결함 PK — resolveSolarModuleWfsProperties 가 module seq 로 오인하지 않게
    const defectPk = defect.seq ?? defect.id;
    if (defectPk == null || Number(ctx.solarModuleSeq) !== Number(defectPk)) {
      solarModuleSeq = ctx.solarModuleSeq;
    }
  }
  const solarStringSeq = pickFirst(defect.solarStringSeq, defect.solar_string_seq);
  const solarArraySeq = pickFirst(defect.solarArraySeq, defect.solar_array_seq);

  const moduleDisplayId = pickFirst(
    ctx.moduleId,
    defect.moduleId,
    defect.module_id,
    solarModuleSeq != null ? String(solarModuleSeq) : null
  );

  const stringDisplayId = pickFirst(
    ctx.stringId,
    defect.stringId,
    defect.string_id,
    solarStringSeq != null ? String(solarStringSeq) : null
  );

  const arrayDisplayId = pickFirst(
    ctx.arrayId,
    defect.arrayId,
    defect.array_id,
    solarArraySeq != null ? String(solarArraySeq) : null
  );

  return {
    solarModuleSeq,
    solarStringSeq,
    solarArraySeq,
    moduleDisplayId,
    stringDisplayId,
    arrayDisplayId
  };
}

/** "Array 1" / "String ?" — displayId 우선, 없으면 DB seq */
export function formatHierarchySegment(entityType, displayId, seq) {
  const label = displayId ?? (seq != null && seq !== '' ? String(seq) : null);
  const prefix = entityType.charAt(0).toUpperCase() + entityType.slice(1);
  return label != null ? `${prefix} ${label}` : `${prefix} ?`;
}

/** Drawer 행 kind별 계층 경로 라벨 */
export function formatDefectDrawerPathLabel(row) {
  const kind = row?.kind || '';
  const id = row.displayId ?? row.seq ?? '?';

  if (kind === 'array_header') return `Array ${id}`;
  if (kind === 'string_header') return `String ${id}`;
  return `Module ${id}`; // panel / panel_single
}
